module.exports = __webpack_public_path__ + "img/deatails_bottom01.cfaa455c.png";